module.exports = __webpack_public_path__ + "static/img/LiveRamp-Selected.eef45d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/LiveRamp-Selected.png
// module id = 606
// module chunks = 0